import { render, staticRenderFns } from "./ModattaObjectRadioInput.vue?vue&type=template&id=0d6c8a06"
import script from "./ModattaObjectRadioInput.vue?vue&type=script&lang=js"
export * from "./ModattaObjectRadioInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports